import { Component } from "@angular/core";

@Component({
  selector: "app-table-loading",
  templateUrl: "./table-loading.component.html",
  styleUrls: ["./table-loading.component.scss"],
})
export class TableLoadingComponent {}
